import { PageController } from '@client/components/_core/layout/PageController';
import { History } from '@client/components/_ui/display/History';
import { RecordCard } from '@client/components/_ui/display/RecordPrimitives';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/configuration/fleet/client-database/details/$id/history')({
    component: RouteComponent,
});

/**
 * Every change to the record and what hangs off it (vehicles, drivers, portal access and, for
 * a reader who may see them, repairer preferences) is already written against the client. This
 * tab is where those rows become visible (CUR-1104).
 */
function RouteComponent() {
    const { orgId, id } = Route.useParams();
    return (
        <PageController route={Route}>
            <RecordCard>
                <History key={`${orgId}:${id}`} idValue={id} idPropertyName="fleetClientId" />
            </RecordCard>
        </PageController>
    );
}
